module.exports = __webpack_public_path__ + "media/images/childcare/cover-mobile-da41e9b94848cf668fc838db4c36605f.jpg";